// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $Country = tag => ({tag});
const PLIsSymbol = {reflectSymbol: () => "PL"};
const GBIsSymbol = {reflectSymbol: () => "GB"};
const RUIsSymbol = {reflectSymbol: () => "RU"};
const ROIsSymbol = {reflectSymbol: () => "RO"};
const CZIsSymbol = {reflectSymbol: () => "CZ"};
const HRIsSymbol = {reflectSymbol: () => "HR"};
const SKIsSymbol = {reflectSymbol: () => "SK"};
const DEIsSymbol = {reflectSymbol: () => "DE"};
const NLIsSymbol = {reflectSymbol: () => "NL"};
const ESIsSymbol = {reflectSymbol: () => "ES"};
const BRIsSymbol = {reflectSymbol: () => "BR"};
const ITIsSymbol = {reflectSymbol: () => "IT"};
const SIIsSymbol = {reflectSymbol: () => "SI"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor))))))))))));
const PL = /* #__PURE__ */ $Country("PL");
const GB = /* #__PURE__ */ $Country("GB");
const RU = /* #__PURE__ */ $Country("RU");
const RO = /* #__PURE__ */ $Country("RO");
const CZ = /* #__PURE__ */ $Country("CZ");
const HR = /* #__PURE__ */ $Country("HR");
const SK = /* #__PURE__ */ $Country("SK");
const DE = /* #__PURE__ */ $Country("DE");
const NL = /* #__PURE__ */ $Country("NL");
const ES = /* #__PURE__ */ $Country("ES");
const BR = /* #__PURE__ */ $Country("BR");
const IT = /* #__PURE__ */ $Country("IT");
const SI = /* #__PURE__ */ $Country("SI");
const eqCountry = {
  eq: x => y => {
    if (x.tag === "PL") { return y.tag === "PL"; }
    if (x.tag === "GB") { return y.tag === "GB"; }
    if (x.tag === "RU") { return y.tag === "RU"; }
    if (x.tag === "RO") { return y.tag === "RO"; }
    if (x.tag === "CZ") { return y.tag === "CZ"; }
    if (x.tag === "HR") { return y.tag === "HR"; }
    if (x.tag === "SK") { return y.tag === "SK"; }
    if (x.tag === "DE") { return y.tag === "DE"; }
    if (x.tag === "NL") { return y.tag === "NL"; }
    if (x.tag === "ES") { return y.tag === "ES"; }
    if (x.tag === "BR") { return y.tag === "BR"; }
    if (x.tag === "IT") { return y.tag === "IT"; }
    if (x.tag === "SI") { return y.tag === "SI"; }
    return false;
  }
};
const ordCountry = {
  compare: x => y => {
    if (x.tag === "PL") {
      if (y.tag === "PL") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "PL") { return Data$dOrdering.GT; }
    if (x.tag === "GB") {
      if (y.tag === "GB") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "GB") { return Data$dOrdering.GT; }
    if (x.tag === "RU") {
      if (y.tag === "RU") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "RU") { return Data$dOrdering.GT; }
    if (x.tag === "RO") {
      if (y.tag === "RO") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "RO") { return Data$dOrdering.GT; }
    if (x.tag === "CZ") {
      if (y.tag === "CZ") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "CZ") { return Data$dOrdering.GT; }
    if (x.tag === "HR") {
      if (y.tag === "HR") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "HR") { return Data$dOrdering.GT; }
    if (x.tag === "SK") {
      if (y.tag === "SK") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "SK") { return Data$dOrdering.GT; }
    if (x.tag === "DE") {
      if (y.tag === "DE") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "DE") { return Data$dOrdering.GT; }
    if (x.tag === "NL") {
      if (y.tag === "NL") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "NL") { return Data$dOrdering.GT; }
    if (x.tag === "ES") {
      if (y.tag === "ES") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ES") { return Data$dOrdering.GT; }
    if (x.tag === "BR") {
      if (y.tag === "BR") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "BR") { return Data$dOrdering.GT; }
    if (x.tag === "IT") {
      if (y.tag === "IT") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "IT") { return Data$dOrdering.GT; }
    if (x.tag === "SI") {
      if (y.tag === "SI") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqCountry
};
const genericCountry = {
  to: x => {
    if (x.tag === "Inl") { return PL; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return GB; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return RU; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return RO; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return CZ; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return HR; }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return SK; }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return DE; }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return NL; }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return ES; }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return BR; }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return IT; }
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return SI; }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "PL") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "GB") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "RU") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "RO") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "CZ") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "HR") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "SK") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    if (x.tag === "DE") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
            )
          )
        )
      );
    }
    if (x.tag === "NL") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
              )
            )
          )
        )
      );
    }
    if (x.tag === "ES") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "BR") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "IT") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "SI") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showCountry = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PLIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(GBIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(RUIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ROIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CZIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(HRIsSymbol);
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(SKIsSymbol);
    const $7 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(DEIsSymbol);
    const $8 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(NLIsSymbol);
    const $9 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ESIsSymbol);
    const $10 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(BRIsSymbol);
    const $11 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ITIsSymbol);
    const $12 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(SIIsSymbol);
    return x => {
      const $13 = genericCountry.from(x);
      if ($13.tag === "Inl") { return $0["genericShow'"]($13._1); }
      if ($13.tag === "Inr") {
        if ($13._1.tag === "Inl") { return $1["genericShow'"]($13._1._1); }
        if ($13._1.tag === "Inr") {
          if ($13._1._1.tag === "Inl") { return $2["genericShow'"]($13._1._1._1); }
          if ($13._1._1.tag === "Inr") {
            if ($13._1._1._1.tag === "Inl") { return $3["genericShow'"]($13._1._1._1._1); }
            if ($13._1._1._1.tag === "Inr") {
              if ($13._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($13._1._1._1._1._1); }
              if ($13._1._1._1._1.tag === "Inr") {
                if ($13._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($13._1._1._1._1._1._1); }
                if ($13._1._1._1._1._1.tag === "Inr") {
                  if ($13._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($13._1._1._1._1._1._1._1); }
                  if ($13._1._1._1._1._1._1.tag === "Inr") {
                    if ($13._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($13._1._1._1._1._1._1._1._1); }
                    if ($13._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($13._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($13._1._1._1._1._1._1._1._1._1); }
                      if ($13._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($13._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1); }
                        if ($13._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($13._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($13._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($13._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $11["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if ($13._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return $12["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1._1); }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeCountry = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericCountry)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("PL"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("GB"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("RU"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("RO"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("CZ"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("HR"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("SK"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("DE"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("NL"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ES"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("BR"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("IT"), Data$dGeneric$dRep.NoArguments)]})({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("SI"), Data$dGeneric$dRep.NoArguments)]
  })))))))))))))(Unscramble$dEnum.defaultEnumOptions)
};
const ufromJSONKeyCountry = /* #__PURE__ */ (() => ({fromJSONKey: Unscramble.$FromJSONKeyFunction("FromJSONKeyValue", unscrambleDecodeCountry.unsafeDecode)}))();
const boundedCountry = /* #__PURE__ */ (() => (
  {
    top: genericCountry.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      )
    )),
    bottom: genericCountry.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordCountry
  }
))();
const enumCountry = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericCountry)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericCountry)(genericEnumSum1),
  Ord0: () => ordCountry
};
const boundedEnumCountry = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericCountry)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"](genericCountry.from(x)),
    Bounded0: () => boundedCountry,
    Enum1: () => enumCountry
  }
))();
const encodeCountry = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericCountry)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("PL"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("GB"); }
        if (v1._1.tag === "Inr") {
          if (v1._1._1.tag === "Inl") { return v.constructorTagTransform("RU"); }
          if (v1._1._1.tag === "Inr") {
            if (v1._1._1._1.tag === "Inl") { return v.constructorTagTransform("RO"); }
            if (v1._1._1._1.tag === "Inr") {
              if (v1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("CZ"); }
              if (v1._1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("HR"); }
                if (v1._1._1._1._1._1.tag === "Inr") {
                  if (v1._1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("SK"); }
                  if (v1._1._1._1._1._1._1.tag === "Inr") {
                    if (v1._1._1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("DE"); }
                    if (v1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (v1._1._1._1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("NL"); }
                      if (v1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (v1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("ES"); }
                        if (v1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (v1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("BR"); }
                          if (v1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (v1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("IT"); }
                            if (v1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return v.constructorTagTransform("SI"); }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const decodeCountry = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericCountry)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(PLIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(GBIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(RUIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ROIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(CZIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(HRIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(SKIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(DEIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(NLIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ESIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(BRIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ITIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(SIIsSymbol))))))))))))))
};
const asJSONKeyCountry = /* #__PURE__ */ (() => ({asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction("AsJSONKeyValue", encodeCountry.encode, decodeCountry.decode)}))();
export {
  $Country,
  BR,
  BRIsSymbol,
  CZ,
  CZIsSymbol,
  DE,
  DEIsSymbol,
  ES,
  ESIsSymbol,
  GB,
  GBIsSymbol,
  HR,
  HRIsSymbol,
  IT,
  ITIsSymbol,
  NL,
  NLIsSymbol,
  PL,
  PLIsSymbol,
  RO,
  ROIsSymbol,
  RU,
  RUIsSymbol,
  SI,
  SIIsSymbol,
  SK,
  SKIsSymbol,
  asJSONKeyCountry,
  boundedCountry,
  boundedEnumCountry,
  decodeCountry,
  encodeCountry,
  enumCountry,
  eqCountry,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericCountry,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericTopConstructor,
  ordCountry,
  showCountry,
  ufromJSONKeyCountry,
  unscrambleDecodeCountry
};
